import gql from 'graphql-tag'
import { DataValue } from 'react-apollo'

export interface OrgData {
  orgId: string
  name: string
}

export type GetServiceUsageQuotaData = DataValue<{
  allOrgs: { data: OrgData[] }
}>

export const listAllOrgsGql = gql`
  query listAllOrgs {
    listAllOrgs @rest(type: "OrgData", path: "/listAllOrgs", endpoint: "query") {
      orgId
      name
    }
  }
`
